import React, { Component } from 'react';
import {Form, Button,  FormGroup, Label, Input, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
class TaggingDetails extends Component {  
     constructor(props) {
          super(props);
          this.state = {
              
          };
        }
       
      
     render() {
          const { tgname, tgdesc} = this.state;
  return (
     <div className='h-100'>
     <div className='main-header'>
       
       <div className='row'>
         <div className='col-md-6'><h2 className="page-header">My Tagged Files</h2></div>
        
       </div>
       </div>
 <div className='main-panel'>
        <div className='content '>
         <div className='container-fluid h-100'>
 <div className='h-100 text-selection-none '>
     
        <div className='row h-100'>
        <div className="col-md-12  h-100">
   <div id="tabledata" className=" position-relative overflowy h-100">
      <table className="table bg-white mb-0">
         <thead>
            <tr>
               
               <th>File Name</th>
               <th>Manufacturer Name</th>
               <th>Tagged Date</th>
               <th>Upload Date</th>
            </tr>
         </thead>
         <tbody>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            <tr>    
                <td>84_Sigma-Aldrich_132191670629220443_289275685.pdf</td>          
                <td>Sigma-Aldrich</td>
                <td>2019-11-25T14:51:03.073</td>
                <td>2019-11-25T14:51:03.073</td>
            </tr>
            
         </tbody>
      </table>
   </div>
</div>
        </div>
      </div>
    </div>
    </div>
    </div>
    </div>
  )};
};

export default TaggingDetails;